module.exports = __webpack_public_path__ + "img/icon-finish.0c99fce3.png";